export default __webpack_public_path__ + "static/media/Rectangle 1032.ae558ca6.png";